import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useCurrency } from '../../context/CurrencyContext';

const CurrencySelector = ({ compact = false }) => {
  const { currency, setCurrency, currencyInfo, allCurrencies } = useCurrency();
  const [open, setOpen] = useState(false);

  const mainCurrencies = ['AUD', 'GBP', 'USD', 'EUR', 'NZD', 'CAD'];

  if (compact) {
    return (
      <div className="relative">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-1 px-2 py-1 text-xs text-stone-600 hover:bg-stone-100 rounded-sm transition-colors"
          data-testid="currency-selector"
        >
          <span>{currencyInfo.flag}</span>
          <span className="font-medium">{currency}</span>
        </button>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <div className="absolute right-0 top-full mt-1 bg-white border border-stone-200 rounded-md shadow-lg z-50 min-w-[160px] py-1">
              {mainCurrencies.map((code) => {
                const info = allCurrencies[code];
                return (
                  <button
                    key={code}
                    onClick={() => { setCurrency(code); setOpen(false); }}
                    className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-stone-50 transition-colors ${
                      currency === code ? 'bg-minted-50 text-minted-800 font-medium' : 'text-stone-700'
                    }`}
                    data-testid={`currency-option-${code}`}
                  >
                    <span>{info.flag}</span>
                    <span>{code}</span>
                    <span className="text-stone-400 text-xs ml-auto">{info.symbol}</span>
                  </button>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1 flex-wrap">
      {mainCurrencies.slice(0, 4).map((code) => {
        const info = allCurrencies[code];
        return (
          <button
            key={code}
            onClick={() => setCurrency(code)}
            className={`flex items-center gap-1 px-2.5 py-1.5 rounded-sm text-xs font-medium transition-colors ${
              currency === code
                ? 'bg-minted-800 text-white'
                : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
            }`}
          >
            <span>{info.flag}</span>
            <span>{code}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CurrencySelector;
